export default __webpack_public_path__ + "assets/logo1.a28b022c.png";